var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPrint = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 3.33331C13.7022 3.33331 14.0007 3.63179 14.0007 3.99998V6.66665H16.0007C16.3689 6.66665 16.6673 6.96513 16.6673 7.33331V14C16.6673 14.3682 16.3689 14.6666 16.0007 14.6666H14.0007V16C14.0007 16.3682 13.7022 16.6666 13.334 16.6666H6.66732C6.29913 16.6666 6.00065 16.3682 6.00065 16V14.6666H4.00065C3.63246 14.6666 3.33398 14.3682 3.33398 14V7.33331C3.33398 6.96513 3.63246 6.66665 4.00065 6.66665H6.00065V3.99998C6.00065 3.63179 6.29913 3.33331 6.66732 3.33331H13.334ZM12.6673 13.3333H7.33398V15.3333H12.6673V13.3333ZM15.334 7.99998H4.66732V13.3333H6.00065V12.6666C6.00065 12.2984 6.29913 12 6.66732 12H13.334C13.7022 12 14.0007 12.2984 14.0007 12.6666V13.3333H15.334V7.99998ZM7.33398 8.66665V9.99998H5.33398V8.66665H7.33398ZM12.6673 4.66665H7.33398V6.66665H12.6673V4.66665Z",
    fill: "#4C5552"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPrint, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/print.78fd932f.svg";
export { ForwardRef as ReactComponent };